import { confirmTransfer } from 'app/src/msw/moneytransfer/api/confirmTransfer'
import { getTransfer } from 'app/src/msw/moneytransfer/api/getTransfer'
import { getTransfers } from 'app/src/msw/moneytransfer/api/getTransfers'

export const moneytransferHandlers = [getTransfers, getTransfer, confirmTransfer]
